import { SmartCollectionResponse } from 'api/product/getSmartCollection/types';
import { resolvedCanonical } from 'components/seo/canonical';
import description from 'components/seo/description';
import image from 'components/seo/image';
import robots from 'components/seo/robots';
import pageTitle from 'components/seo/title';
import seotype from 'components/seo/type';
import { useConfig } from 'config/use-config';
import { useContentful } from 'modules/content-cms/components/context';
import Head from 'next/head';
import { FC } from 'react';
import { jsonLdScriptProps } from 'react-schemaorg';
import { ItemList } from 'schema-dts';

interface CollectionHeadProps {
  canonicalUrl: string;
  collection: SmartCollectionResponse;
}

const CollectionHead: FC<CollectionHeadProps> = ({ canonicalUrl, collection }) => {
  const { frontendUrl } = useConfig();
  const { data: contentful } = useContentful();

  return (
    <Head>
      {pageTitle(contentful.fields.headline || collection.title)}
      {description(contentful.fields.metaDescription)}
      {seotype('product.group')}
      {robots(contentful.fields.metaRobots)}
      {resolvedCanonical(canonicalUrl)}
      {image(contentful.fields.metaOgImage?.fields.file.url)}
      <script
        {...jsonLdScriptProps<ItemList>({
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: collection.items.map((product, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            url: `${frontendUrl}/products/${product.slug}`,
          })),
        })}
      />
    </Head>
  );
};

export default CollectionHead;
